<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <!--コンテンツ-->
    <main id="renew2_mypage">
        <div class="top_container renew2_pc">
            <div class="renew2_wrapper renew2_flex">
                <div class="servicelist">
                    <ul class="servicelist__block">
                        <li class="servicelist__item onclick"><a href="/mypage"><img
                                    src="/static/renew2_img/icon_mypagetop.svg" alt="マイページ"><br>マイページ</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/yagioffer"><img
                                    src="/static/renew2_img/icon_yagioffer.svg" alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickmail"><img
                                    src="/static/renew2_img/icon_quickmail.svg" alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/quickemail"><img
                                    src="/static/renew2_img/icon_quickemail.svg" alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li class="servicelist__item waiting"><a href="/mypage/introduction"><img
                                    src="/static/renew2_img/icon_recommend.svg" alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                </div>
                <div class="mypage_contents">
                    <h2>マイページ</h2>
                    <p>マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" style="color:#ff0000;text-decoration:underline; text-decoration-color:#FF0000;">旧マイページ</a>にアクセスしてください。</p>
                    <div class="renew2_flex mypage_contents__01">
                        <div class="member_info">
                            <div class="renew2_flex member_info__block">
                                <div>
                                  <p class="member_name"><span class="member_name_big">{{username}}</span>さん<br>
                                  <span v-if="useremail" class="member_name_mail">({{useremail}})</span></p>
                                  <ul>
                                      <li><a href="/mypage/basicinfo">メールアドレスの変更</a></li>
                                      <li v-if="$site.appFlag!='b'"><a href="/account/delete">その他の設定</a></li>
                                      <li v-else><a href="/account/delete">退会やその他の設定</a></li>
                                  </ul>
                                </div>
                                <!--登録メールアドレス＝会員名前-->
                                <div class="yagi_info" v-if="$firebase.user.emailVerified">

                                    <your-yagi :your-yagi-class="{}"
                                      :yagi-options="{dialogEnabled: true, rubyEnabled: false, messageEnabled: true}"></your-yagi>
                                    <!-- <img src="https://placehold.jp/150x150.png" alt="あなたのヤギ" class="yagi_img"> -->
                                    <p class="yagi_title">あなたのヤギ</p>
                                </div>
                                <div class="yagi_info" v-else>
                                  メール未確認状態
                                  <button type="button" class="el-button el-button--success joblist-btn"
                                  @click="sendEmailVerification"
                                      id="send-mynabi-pdf"><!----><!----><span>確認メールを送信する</span></button>
                                </div>
                            </div>

                        </div>
                        <div class="contents_left">
                            <div class="sakusei_history">
                                <h3>書式のご利用状況</h3>
                                <ul v-if="mypagedata && mypagedata.format_ids">
                                    <li v-for="(item, index) in mypagedata.format_ids" :key="index" ><a :href="'/format/'+item.format_id">{{getFormatName(item.format_id)}}</a></li>
                                </ul>
                                <p v-else>現在、利用履歴はありません。</p>
                            </div>
                            <div class="sakusei_history renew2_flex font_history" v-if="mypagedata.fontpayment > 0">
                                <h3>フォント購入</h3>
                                <p>購入済み</p>
                                <!--<a href="">いつでも購入できます</a>-->
                            </div>
                            <div class="sakusei_history renew2_flex font_history" v-else-if="$globalVar.in_app_payments">
                                <h3>フォント購入</h3>
                                <p ><a href="/fontservicehelp" >購入する</a></p>
                                <!--<a href="">いつでも購入できます</a>-->
                            </div>
                        </div>

                    </div>
                    <div class="renew2_flex mypage_contents__02">


                      <div id="renew2_popup_joblist_carat">
                        <div class="popup_block">

                          <div class="carat_terms">
                              <h3 class="joblist_recommend__title_carat"><img src="/static/renew2_img/carath3.png" style="width: 450px; margin-bottom: 10px;"></h3>
                              <div>
                                  <p>Yagishの<a href="https://rirekisho.yagish.jp/terms"
                                          target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/"
                                          target="_blank">個人情報保護方針</a>、Caratの<a
                                          href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                                  <p><img src="/static/renew_img/check_icon.png" alt="同意する"
                                          style="height: 20px;">規約に同意して問い合わせる</p>
                              </div>
                          </div>
                          <div class="renew2_flex popup_item mypage-carat">
                              <div v-for="(item, index) in job_list" class="carat_block" v-show="!item.is_applicated ">
                                  <h4 class="ranking-h4" v-if="index==0"><img src="/static/renew2_img/carath4_01.png" style="height:65px;" ></h4>
                                  <h4 class="ranking-h4" v-else-if="index==1"><img src="/static/renew2_img/carath4_02.png" style="height:65px;" ></h4>
                                  <h4 class="ranking-h4" v-else-if="index==2"><img src="/static/renew2_img/carath4_03.png" style="height:65px;" ></h4>
                                  <h4 class="ranking-h4" v-else>{{index+1}}位</h4>
                                  <a>
                                      <div class="joblist_link">
                                          <div class="joblist_link01" @click="clickCarat(item.id)">
                                              <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                              <p class="txt_area">{{ item.work_location }}</p>
                                          </div>
                                          <div class="joblist_link02" @click="clickCarat(item.id)">
                                              <h4 class="joblist_h4">{{ item.title }}</h4>
                                              <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p><!---->
                                              <p class="joblist_txt"
                                                  style="color: rgb(227, 22, 92); opacity: 1; ">
                                                  {{ item.salary }}</p>
                                          </div><button type="button" id="send-carat-application"
                                                      @click="applicantCarat(item.id);item.is_applicated=true"
                                                      class="el-button el-button--success carat_btn"><span
                                                        >話を聞いてみる</span></button>
                                      </div>
                                  </a><a @click="clickCarat(item.id)" >この求人の詳細を見る&#9650;</a>
                              </div>
                          </div>




                            <div class="carat_terms" v-if="false">
                                <h3 class="joblist_recommend__title_carat">あなたにオススメ！求人情報</h3>
                                <div>
                                    <p>Yagishの<a href="https://rirekisho.yagish.jp/terms"
                                            target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/"
                                            target="_blank">個人情報保護方針</a>、Caratの<a
                                            href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a"
                                            target="_blank">プライバシーポリシー</a>
                                    </p>
                                    <p><img src="/static/renew_img/check_icon.png" alt="同意する"
                                            style="height: 20px;">規約に同意して問い合わせる</p>
                                </div>
                            </div>
                            <div class="renew2_flex popup_item" v-if="false">
                                <div class="carat_left">
                                    <div v-for="(item, index) in job_list" class="carat_block" v-show="index % 2 == 1 && !item.is_applicated && index <= 5"><a>
                                            <div class="joblist_link">
                                                <div class="joblist_link01" @click="clickCarat(item.id)">
                                                    <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                                    <p class="txt_area">{{ item.work_location }}</p>
                                                </div>
                                                <div class="joblist_link02" @click="clickCarat(item.id)">
                                                    <h4 class="joblist_h4">{{ item.title }}</h4>
                                                    <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                                    <p v-if="false" class="joblist_txt"
                                                        stylex="color: rgb(227, 22, 92); opacity: 1; font-weight: bold;">{{ item.salary.slice(0, 100) }}...</p>
                                                    <p class="joblist_txt"
                                                        style="color: rgb(227, 22, 92); opacity: 1; ">{{ item.salary }}</p>
                                                </div>
                                                <button type="button" id="send-carat-application"
                                                    @click="applicantCarat(item.id);item.is_applicated=true"
                                                    class="el-button el-button--success carat_btn"><span
                                                      >話を聞いてみる</span></button>
                                            </div>
                                        </a><!---->
                                        <a @click="clickCarat(item.id)" >この求人の詳細を見る&#9650;</a>
                                    </div>
                                </div>
                                <div class="carat_right">
                                    <div v-for="(item, index) in job_list" class="carat_block" v-show="index % 2 == 0 && !item.is_applicated && index <= 5"><a>
                                            <div class="joblist_link">
                                                <div class="joblist_link01" @click="clickCarat(item.id)">
                                                    <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                                    <p class="txt_area">{{ item.work_location }}</p>
                                                </div>
                                                <div class="joblist_link02" @click="clickCarat(item.id)">
                                                    <h4 class="joblist_h4">{{ item.title }}</h4>
                                                    <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                                    <p v-if="false" class="joblist_txt"
                                                        stylex="color: rgb(227, 22, 92); opacity: 1; font-weight: bold;">{{ item.salary.slice(0, 100) }}...</p>
                                                    <p
                                                        style="color: rgb(227, 22, 92); opacity: 1; " class="joblist_txt">{{ item.salary }}</p>
                                                </div>
                                                <button type="button" id="send-carat-application"
                                                    @click="applicantCarat(item.id);item.is_applicated=true"
                                                    class="el-button el-button--success carat_btn"><span
                                                      >話を聞いてみる</span></button>
                                            </div>
                                        </a><!---->
                                        <a @click="clickCarat(item.id)" >この求人の詳細を見る&#9650;</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>

                        <div class="joblist_recommend" v-if="getMode != 'production' && false">
                          <div class="joblist_recommend__title">
                              <h3>あなたにオススメ！求人情報</h3><!---->
                          </div>
                          <div class="joblist_recommend__block">

                              <div v-for="(item, index) in job_list" class="carat_block">
                                  <a  target="_blank" class="joblist-link" @click="clickCarat(item.id)" >
                                      <div class="joblist">
                                          <div class="joblist1">
                                              <p class="joblist1-jt" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                              <p>{{ item.salary }}</p>
                                          </div>
                                          <h4 class="joblist2">{{ item.title }}</h4>
                                          <p class="joblist3">{{ item.work_location }}</p>
                                          <button type="button" id="send-mynabi-pdf"
                                          @click="applicantCarat(item.id);item.is_applicated=true"
                                          class="el-button el-button--success carat_btn"><span>規約に同意して応募</span>
                                          </button>
                                      </div><!---->
                                  </a>
                                  <a @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
                              </div>

                          </div>
                        </div>
                    </div>
                    <div class="out_block">
                        <a href="#" @click="$firebase.signOut();$event.preventDefault()" class="out_btn">ログアウト</a>
                    </div>
                </div>
            </div>
        </div>

        <!--SP-->
        <div class="top_container renew2_sp">
            <div class="renew2_wrapper">
                <h2>マイページ</h2>
                <p>マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" style="color:#ff0000;text-decoration:underline; text-decoration-color:#FF0000;">旧マイページ</a>にアクセスしてください。</p>
                <div class="member_info renew2_sp_flex">
                    <div>
                      <p class="member_name"><span>{{username}}</span>さん</p><!--登録メールアドレス＝会員名前-->
                      <ul>
                          <li><a href="/mypage/basicinfo">メールアドレスの変更</a></li>
                          <li v-if="$site.appFlag!='b'"><a href="/account/delete">その他の設定</a></li>
                          <li v-else><a href="/account/delete">退会やその他の設定</a></li>
                      </ul>
                    </div>
                    <div class="yagi_info" v-if="$firebase.user.emailVerified">
                        <your-yagi :your-yagi-class="{}"
                                      :yagi-options="{dialogEnabled: true, rubyEnabled: false, messageEnabled: true}"></your-yagi>
                        <p class="yagi_title">あなたのヤギ</p>
                    </div>
                    <div class="yagi_info" v-else>
                      メール未確認状態
                      <button type="button" class="el-button el-button--success joblist-btn"
                      @click="sendEmailVerification"
                          id="send-mynabi-pdf"><!----><!----><span>確認メール送信</span></button>
                    </div>
                </div>
                <div class="sakusei_history">
                    <h3>書式のご利用状況</h3>
                    <ul v-if="mypagedata && mypagedata.format_ids">
                        <li v-for="(item, index) in mypagedata.format_ids" :key="index" ><a :href="'/format/'+item.format_id">{{getFormatName(item.format_id)}}</a></li>
                    </ul>
                    <p v-else>現在、利用履歴はありません。</p>
                </div>
                <div class="sakusei_history renew2_sp_flex font_history" v-if="mypagedata.fontpayment > 0" >
                    <h3>フォント購入</h3>
                    <p>購入済み</p>
                    <!--<p>いつでも購入できます</p>-->
                </div>
                <div class="sakusei_history renew2_sp_flex font_history" v-else-if="$globalVar.in_app_payments">
                    <h3>フォント購入</h3>
                     <p v-if="$site.appFlag!='b' || true"><a href="/fontservicehelp" >購入する</a></p>
                     <p v-else>購入してない</p>
                    <!--<p>いつでも購入できます</p>-->
                </div>
                <div class="servicelist">
                    <h3>各種サービスのご利用状況</h3>
                    <ul class="renew2_sp_flex servicelist__block">
                        <li><a href="/mypage/yagioffer"><img src="/static/renew2_img/icon_yagioffer.svg"
                                    alt="ヤギオファー"><br>ヤギオファー</a></li>
                        <li><a href="/mypage/quickmail"><img src="/static/renew2_img/icon_quickmail.svg"
                                    alt="ヤギの宅配便"><br>ヤギの宅配便</a></li>
                        <li><a href="/mypage/quickemail"><img src="/static/renew2_img/icon_quickemail.svg"
                                    alt="ヤギのメール便"><br>ヤギのメール便</a></li>
                        <li><a href="/mypage/introduction"><img src="/static/renew2_img/icon_recommend.svg"
                                    alt="推薦・紹介文"><br>推薦・紹介文</a></li>
                    </ul>
                </div>
                <div id="renew2_popup_joblist_carat">
                    <div class="popup_block">
                        
                        <div class="carat_terms">
                            <h3 class="joblist_recommend__title_carat"><img src="/static/renew2_img/carath3.png" style="width: 100%;"></h3>
                            <div>
                                <p>Yagishの<a href="https://rirekisho.yagish.jp/terms"
                                        target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/"
                                        target="_blank">個人情報保護方針</a>、Caratの<a
                                        href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                                <p><img src="/static/renew_img/check_icon.png" alt="同意する"
                                        style="height: 20px;">規約に同意して問い合わせる</p>
                            </div>
                        </div>
                        <div class="popup_item" style="height: auto;width: 100%;margin: auto;padding: 0;">
                            <div v-for="(item, index) in job_list" class="carat_block" v-show="!item.is_applicated">
                                <h4 class="ranking-h4" v-if="index==0"><img src="/static/renew2_img/carath4_01.png" style="height:65px;" ></h4>
                                <h4 class="ranking-h4" v-else-if="index==1"><img src="/static/renew2_img/carath4_02.png" style="height:65px;" ></h4>
                                <h4 class="ranking-h4" v-else-if="index==2"><img src="/static/renew2_img/carath4_03.png" style="height:65px;" ></h4>
                                <h4 class="ranking-h4" v-else>{{index+1}}位</h4>
                                <a>
                                    <div class="joblist_link">
                                        <div class="joblist_link01" @click="clickCarat(item.id)">
                                            <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                            <p class="txt_area">{{ item.work_location }}</p>
                                        </div>
                                        <div class="joblist_link02" @click="clickCarat(item.id)">
                                            <h4 class="joblist_h4">{{ item.title }}</h4>
                                            <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p><!---->
                                            <p class="joblist_txt"
                                                style="color: rgb(227, 22, 92); opacity: 1; ">
                                                {{ item.salary }}</p>
                                        </div><button type="button" id="send-carat-application"
                                                    @click="applicantCarat(item.id);item.is_applicated=true"
                                                    class="el-button el-button--success carat_btn"><span
                                                      >話を聞いてみる</span></button>
                                    </div>
                                </a><a @click="clickCarat(item.id)" >この求人の詳細を見る&#9650;</a>
                            </div>
                            <div class="carat_block" v-for="(item, index) in job_list" v-show="false"><a>
                                    <div class="joblist_link">
                                        <div class="joblist_link01" @click="clickCarat(item.id)">
                                            <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                            <p class="txt_area">{{ item.work_location }}</p>
                                        </div>
                                        <div class="joblist_link02" @click="clickCarat(item.id)">
                                            <h4 class="joblist_h4">{{ item.title }}</h4>
                                            <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                            <p class="joblist_txt"
                                                style="color: rgb(227, 22, 92); opacity: 1; font-weight: bold;">{{ item.salary.slice(0, 20) }}...</p>
                                        </div><button type="button" id="send-carat-application"
                                            @click="applicantCarat(item.id);item.is_applicated=true"
                                            class="el-button el-button--success carat_btn"><span
                                              >話を聞いてみる</span></button>
                                    </div>
                                </a><!---->
                                <a @click="clickCarat(item.id)" >この求人の詳細を見る&#9650;</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="joblist_recommend" v-if="mypagedata.memberdata && mypagedata.memberdata.job_list && getMode == 'production' && false">
                    <div class="joblist_recommend__title">
                        <h3>あなたにオススメ！求人情報</h3>
                        <img src="/static/renew2_img/logo_box.png" alt="求人ボックス">
                        <a v-if="false" href="" class="listlink">一覧を見る</a><!--求人サイトへのリンク-->
                    </div>
                    <div class="joblist_recommend__block" v-if="mypagedata.memberdata">


                        <a v-for="(item, index) in mypagedata.memberdata.job_list.results" @click="clickJob(item)" :key="index" :href="item.url"  target="_blank" class="joblist-link"><!--url-->
                            <div class="joblist">
                                <div class="joblist1">
                                    <p class="joblist1-jt">{{item.jt}}</p><!--jt-->
                                    <p>{{item.st}}</p><!--st-->
                                </div>
                                <h4 class="joblist2">{{item.title}}</h4><!--title-->
                                <p class="joblist3">{{item.company}}／{{item.area}}</p><!--area-->
                                <p class="joblist4">{{item.snippet}}</p>
                                <!--snippet-->
                            </div>
                            <button type="button" class="el-button el-button--success joblist-btn" v-if="false"
                                id="send-mynabi-pdf"><!----><!----><span>詳しく見る</span></button>
                        </a>
                    </div>
                </div>

                <div class="joblist_recommend" v-if="getMode != 'production' && false">
                  <div class="joblist_recommend__title">
                      <h3>あなたにオススメ！求人情報</h3><!---->
                  </div>
                  <div class="joblist_recommend__block">

                    <div v-for="(item, index) in job_list"  class="carat_block">
                        <a target="_blank" class="joblist-link" @click="clickCarat(item.id)" >
                            <div class="joblist">
                                <div class="joblist1">
                                    <p class="joblist1-jt" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                    <p>{{ item.salary }}</p>
                                </div>
                                <h4 class="joblist2">{{ item.title }}</h4>
                                <p class="joblist3">{{ item.work_location }}</p>
                                <button type="button" id="send-mynabi-pdf"
                                @click="applicantCarat(item.id);item.is_applicated=true"
                                class="el-button el-button--success carat_btn"><span>規約に同意して応募</span>
                                </button>
                            </div><!---->
                        </a>
                        <a @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
                    </div>
                  </div>
                </div>
                <div class="out_block">
                    <a href="#" @click="$firebase.signOut();$event.preventDefault()" class="out_btn">ログアウト</a>
                </div>
                <ul class="recommend_bnr" style="display: none;">
                    <li class="recommend_bnr__item"><a href=""><img src="https://placehold.jp/350x80.png" alt="バナー"></a>
                    </li>
                    <li class="recommend_bnr__item"><a href=""><img src="https://placehold.jp/350x80.png" alt="バナー"></a>
                    </li>
                </ul>
            </div>
        </div>
    </main>
</div>
</template>

<style lang="css" src="@/assets/css/renew2_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>

<style scoped>
</style>

<style scoped>
  #renew2_mypage .top_container .joblist_recommend__block .joblist-link .joblist{
      margin-bottom: 10px;
  }

  #renew2_mypage .top_container .joblist_recommend__block .joblist-link .joblist .carat_btn {
      background-color: #E3165C;
      border-color: #E3165C;
      margin-top: 10px;
      width: 100%;
  }

  #renew2_mypage .top_container .joblist_recommend__block .joblist_detail_link {
      font-size: 0.8rem;
      display: block;
      text-align: center;
  }
</style>

<style scoped>

#renew2_popup_joblist_carat .popup_block{
        text-align: center;
    }
    #renew2_popup_joblist_carat .popup_block .txt_block .txt02{
        font-size: 1.2rem;
        line-height: 1.5;
        margin-top: 10px;
    }
    #renew2_popup_joblist_carat .popup_block .txt_block .txt03{
        border-bottom: 3px solid #FFF620;
        display: inline-block;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item{
        background: #eef5e8;
        padding: 20px;
        width: calc(100% + 80px);
        margin: 15px -40px;
        height: 55vh;
        overflow: scroll;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .carat_block{
        margin-top: 30px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .carat_block:first-child{
        margin-top: 0;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .carat_block .carat_wrap{
        position: relative;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .carat_block .carat_wrap .carat_link{
        position: absolute;
        inset: 0;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link{
        background: #fff;
        padding: 10px 20px;
        margin: 10px 20px;
        border-radius: 8px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link01{
        display: flex;
        align-items: center;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link01 .txt_category{
        background: rgb(15, 153, 52);
        color: rgb(255, 255, 255);
        border-radius: 50px;
        padding: 2px 10px;
        margin-right: 5px;
        font-size: 0.5rem;
        flex-wrap: wrap;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link01 .txt_salary{
        flex-wrap: wrap;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link02 .joblist_h4{
        color: #004d40;
        padding: 5px 0;
        line-height: 1.4;
        font-size: .9rem;
        text-align: left;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link02 .joblist_txt{
        opacity: .5;
        font-size: .8rem;
        text-align: left;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .carat_btn{
        background-color: #E3165C;
        border-color: #E3165C;
        margin-top: 10px;
        width: 100%;
        position: relative;
        z-index: 1;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_detail_link{
        font-size: 0.8rem;
        position: absolute;
        bottom: 220px;
        left: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
    }
    
    .carat_terms {
        text-align: left;
    }

    .joblist_recommend__title_carat {
        color: #0f9934;
        font-size: 1rem;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .popup_item {
        padding: 0;
        width: 100%;
        margin: 0;
        height: auto;
        overflow: visible;
        justify-content: space-between;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .popup_item  .joblist_link{
        margin: 0;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .popup_item  .carat_left{
        width: 49%;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .popup_item  .carat_right{
        width: 49%;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .popup_item  .carat_block{
        margin-top: 0;
    }
</style>

<style scoped>
    .joblist_recommend__title_carat .ranking-title{
        font-size: 1.4rem;
    }

    .joblist_recommend__title_carat .ranking-title span{
        color: #e3165c;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .mypage-carat {
        flex-wrap: wrap;
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .popup_item .carat_block {
        width: 49%;
        /*追加*/
    }

    #renew2_mypage .top_container .mypage_contents__02 .popup_block .mypage-carat .ranking-h4 {
        margin-bottom: -20px;
        margin-top: 20px;
        text-align: left;
        color: #0f9934;
    }
</style>


<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible:false,
      username:'',
      useremail:'',
      selectedYagiOfferData:{},
      selectedQuickEmailData:{},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      joblistKeyword: '',
      joblistArea: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions:{
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code:'',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      job_list:[],
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho',
      search_id:''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    getFormatName:function(format_id) {
      for(let p of this.$site.formatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      for(let p of this.$site.keirekishoFormatsIndex){
        if (p.id == format_id) {
          return p.title
        }
      }
      return '-'
    },
    clickJob: async function (_item) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', 'mypage')
      formData.append('keyword', this.joblistKeyword)
      formData.append('area', this.joblistArea)


      formData.append('jt', _item.jt)
      formData.append('st', _item.st)
      formData.append('title', _item.title)
      formData.append('company', _item.company)
      formData.append('snippet', _item.snippet)
      formData.append('clicklink', _item.url)


      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)

      const app = this
      this.$axios.post(this.$varuna.endPoints.clickKakakuJob, formData, {timeout: 60000})
    },
    clickCarat: async function (_item) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      this.search_id = ''
      this.$eventHub.$emit('open-carat-dialog', 'mypage', null, this.joblistKeyword, this.joblistArea, null, 2, _item, this.search_id)

      
      // const formData = new FormData()
      // formData.append('uuid', this.$firebase.user.uid)
      // formData.append('format_id', 'mypage')
      // formData.append('occupation', '正社員')

      // formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      // formData.append('version', '2')
      // formData.append('site_flag', 'r')
      // formData.append('app_flag', this.$site.appFlag)

      // const app = this
      // this.$axios.post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
    },
    applicantCarat: async function (jobid) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', 'mypage')
      this.search_id = ''
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', '')
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mypage')
      formData.append('permission_type', 1)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      }  else {
        formData.append('keyword', this.joblistKeyword)
      }
      formData.append('area', this.joblistArea)

      formData.append('occupation', '正社員')
      
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
        .then(function (response) {
          // app.nowStep = 3
          // app.isSended = false
          app.$message({
            message: '応募完了しました。',
            type: 'info'
          })
          for (var _key in app.job_list) {
            if (app.job_list[_key].id==jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
          // app.$eventHub.$emit('open-carat-dialog', 'mypage', null, app.joblistKeyword, app.joblistArea, null, 3, jobid, app.search_id)
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendEmailVerification: async function() {
      const app = this
      await this.$firebase.user.sendEmailVerification().then(() => {
        app.$message({
          message: '送信しました。メール内のリンクをクリックしてください',
          type: 'success'
        })
        
      }).catch((error) => {
        app.$message({
          message: '送信失敗しました。',
          type: 'error'
        })
      })
    }
  },
  created: function () {
    
    const app = this
    console.error("created:"+this.$route.query.custom_token)
    if (this.$route.query.custom_token) {

      firebase.auth().signInWithCustomToken(this.$route.query.custom_token)
      .then((userCredential) => {
        let user = userCredential.user
        if (user) {    
          console.log('mypage logined')
          const formData = new FormData()
          formData.append('uuid', user.uid)
          formData.append('version', '2')
          formData.append('reqflg', '2')
          formData.append('email', user.email)
          formData.append('site_flag', 'r')
          formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
          formData.append('email_verified', user.emailVerified?'1':'0')

          app.$axios
            .post(app.$varuna.endPoints.getMypageHistory, formData, {timeout: 60000})
            .then(function (response) {
              app.mypagedata = response.data
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else if (app.mypagedata.memberdata.lastname) {
                app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
              console.error(app.mypagedata.memberdata.offers)
              app.joblistKeyword = app.mypagedata.memberdata.keyword
              app.joblistArea = app.mypagedata.memberdata.area
              app.job_list = app.mypagedata.memberdata.offers.offers
              app.search_id = app.mypagedata.memberdata.offers.search_id

            })
            .catch(function (error) {
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
            }).finally(function () {
            })

          app.fullscreenLoading = false

        }
        

      })
      .catch((error) => {
        var errorCode = error.code
        var errorMessage = error.message
        console.error(errorCode+errorMessage)

      })
    } else {
      // console.log(this.$route.query.mynavi)
      firebase.auth().onAuthStateChanged((user) => {
        console.log('mypage onAuthStateChanged')
        if (user) {    
          console.log('mypage logined')
          const formData = new FormData()
          formData.append('uuid', user.uid)
          formData.append('version', '2')
          formData.append('reqflg', '2')
          formData.append('email', user.email)
          formData.append('site_flag', 'r')
          formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP': 'PC')
          formData.append('email_verified', user.emailVerified?'1':'0')
          var affiliate_id  = this.$cookies.get('_YAGISH_AFFILIATE_ID')
          if (affiliate_id) formData.append('affiliate_id', affiliate_id)

          app.$axios
            .post(app.$varuna.endPoints.getMypageHistory, formData, {timeout: 60000})
            .then(function (response) {
              app.mypagedata = response.data
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else if (app.mypagedata.memberdata.lastname) {
                app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
              console.error(app.mypagedata.memberdata.offers)
              app.joblistKeyword = app.mypagedata.memberdata.keyword
              app.joblistArea = app.mypagedata.memberdata.area
              app.job_list = app.mypagedata.memberdata.offers.offers
              app.search_id = app.mypagedata.memberdata.offers.search_id

            })
            .catch(function (error) {
              if (app.$firebase.user.displayName) {
                app.username = app.$firebase.user.displayName
                app.useremail = app.$firebase.user.email
              } else {
                app.username = app.$firebase.user.email
              }
            }).finally(function () {
            })

          app.fullscreenLoading = false

        } else {
          console.log('mypage login')
          app.$router.push('/login')
        }
      })
    }

        
  },
  beforeMount: function () {
    console.error("beforeMount:"+this.$route.query.custom_token)
  },
  destroyed: function () {
  }
}
</script>
